import type { AdUnitDefinition } from 'prebid.js'

import type { AdProviderTypes } from '@/types'
import type { LoggerEvent } from '@/types/logger.types'

import type { AdType } from '../../types'

export const APS_ACCOUNT_ID = 'aff2f88f-029a-4051-97cc-2453bc61d867'

export const APS_TARGETING_KEYS = ['amzniid', 'amznbid', 'amznp', 'amznsz', 'amznactt'] as const

export type ApsTargeting = Partial<Record<(typeof APS_TARGETING_KEYS)[number], string>>

export type ApsAdUnit = Pick<AdUnitDefinition, 'code' | 'mediaTypes'>

export type ApsBidContext = {
    placement: AdType
    provider: AdProviderTypes
    slotElementId?: string
    adRequestId?: number
}

export type ApsOptions = {
    pubID: string
    logEvent: (event: LoggerEvent) => void
}

export type Apstag = {
    init(config: { pubID: string; adServer: 'googletag' }): void
    fetchBids(
        bidConfig: { slots: { slotID: string; slotName: string; sizes: [number, number][] }[]; timeout: number },
        // `meta` is not part of the documented API, apstag.js passes it as of 26.910
        callback: (bids: (ApsTargeting & { slotID: string })[], meta?: { fromTimeout: boolean }) => void,
    ): void
    debug(command: 'enableConsole' | 'disableConsole'): void
}
